import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const code = params.get("code");
    if (!code) { setError("No invite code found in this link."); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/accept-invite", { code });
        setUser(data);
        navigate("/app/dashboard", { replace: true });
      } catch (e) {
        setError(formatApiError(e.response?.data?.detail) || "This invite link is invalid or expired.");
      }
    })();
  }, [params, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4 px-6 text-center" data-testid="accept-invite-error">
        <div className="h-10 w-10 rounded-xl bg-primary flex items-center justify-center"><Home className="h-5 w-5 text-primary-foreground" /></div>
        <h1 className="font-heading text-2xl font-bold">Look Before You Leap 808</h1>
        <p className="text-muted-foreground max-w-sm">{error}</p>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate("/login")} className="rounded-full">Log in</Button>
        </div>
        <p className="text-xs text-muted-foreground max-w-sm">This workspace is invite-only. If your link isn't working, contact Marlene for a new invite.</p>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="accept-invite-loading">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-muted-foreground text-sm">Setting up your workspace…</p>
    </div>
  );
}
